var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      !_vm.disabled
        ? _c("vxe-toolbar", {
            scopedSlots: _vm._u(
              [
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _c(
                        "vxe-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.addTable()
                            },
                          },
                        },
                        [_vm._v("添加行")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2279914514
            ),
          })
        : _vm._e(),
      _c(
        "vxe-table",
        { attrs: { data: _vm.cdList } },
        [
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "tableNumMin",
              title: "宴席桌数下限",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 0,
                        placeholder: "宴席桌数下限",
                      },
                      model: {
                        value: row.tableNumMin,
                        callback: function ($$v) {
                          _vm.$set(row, "tableNumMin", $$v)
                        },
                        expression: "row.tableNumMin",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "tableNumMax",
              title: "宴席桌数上限",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 0,
                        placeholder: "宴席桌数上限",
                      },
                      model: {
                        value: row.tableNumMax,
                        callback: function ($$v) {
                          _vm.$set(row, "tableNumMax", $$v)
                        },
                        expression: "row.tableNumMax",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "awardLat", title: "奖励纬度" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row, rowIndex }) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择奖励纬度",
                          disabled: _vm.disabled,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.banquetAwardLatTypeChange(
                              $event,
                              rowIndex
                            )
                          },
                        },
                        model: {
                          value: row.awardLat,
                          callback: function ($$v) {
                            _vm.$set(row, "awardLat", $$v)
                          },
                          expression: "row.awardLat",
                        },
                      },
                      _vm._l(_vm.banquetAwardLatTypeList, function (item) {
                        return _c("el-option", {
                          key: item.dictCode,
                          attrs: {
                            label: item.dictValue,
                            value: item.dictCode,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "rewardType",
              title: "奖励类型",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row, rowIndex }) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择奖励类型",
                          disabled: _vm.disabled,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.banquetAwardTypeChange($event, rowIndex)
                          },
                        },
                        model: {
                          value: row.rewardType,
                          callback: function ($$v) {
                            _vm.$set(row, "rewardType", $$v)
                          },
                          expression: "row.rewardType",
                        },
                      },
                      _vm._l(_vm.banquetAwardTypeList, function (item) {
                        return _c("el-option", {
                          key: item.dictCode,
                          attrs: {
                            label: item.dictValue,
                            value: item.dictCode,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "rewardAmount",
              title: "每桌奖励费用",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 2,
                        placeholder: "每桌奖励费用",
                      },
                      model: {
                        value: row.rewardAmount,
                        callback: function ($$v) {
                          _vm.$set(row, "rewardAmount", $$v)
                        },
                        expression: "row.rewardAmount",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          !_vm.disabled
            ? _c("vxe-column", {
                attrs: { title: "操作", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row, rowIndex }) {
                        return [
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletRow(row, rowIndex)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3921525946
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }